(function(){
  "use strict";

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;

  /* ---------- NAV: scrolled state + active link ---------- */
  var nav = document.getElementById('siteNav');
  var sections = Array.prototype.slice.call(document.querySelectorAll('section[id]'));
  var navLinks = Array.prototype.slice.call(document.querySelectorAll('.nav-links a'));
  var toTop = document.getElementById('toTop');
  var heroSection = document.querySelector('.hero');
  var heroMark = document.querySelector('.hero-mark');

  function onScroll(){
    var y = window.scrollY || window.pageYOffset;
    nav.classList.toggle('scrolled', y > 30);
    toTop.classList.toggle('show', y > 700);

    var current = null;
    sections.forEach(function(sec){
      var rect = sec.getBoundingClientRect();
      if (rect.top <= 140 && rect.bottom >= 140) current = sec.id;
    });
    navLinks.forEach(function(a){
      a.classList.toggle('active', current && a.getAttribute('href') === '#' + current);
    });

    // subtle hero parallax
    if (heroMark && heroSection && !prefersReducedMotion) {
      var heroH = heroSection.offsetHeight;
      var progress = Math.min(Math.max(y / heroH, 0), 1);
      heroMark.style.transform = 'translateY(' + (progress * 40) + 'px)';
    }
  }
  document.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  toTop.addEventListener('click', function(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- HERO INTRO ---------- */
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      if (heroSection) heroSection.classList.add('loaded');
    });
  });

  /* ---------- MAGNETIC BUTTONS ---------- */
  if (!isTouch && !prefersReducedMotion) {
    var magneticEls = Array.prototype.slice.call(document.querySelectorAll('.btn-primary, .btn-ghost, .nav-cta'));
    magneticEls.forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var rect = el.getBoundingClientRect();
        var relX = e.clientX - rect.left - rect.width / 2;
        var relY = e.clientY - rect.top - rect.height / 2;
        var pull = 0.25;
        var maxShift = 10;
        var tx = Math.max(Math.min(relX * pull, maxShift), -maxShift);
        var ty = Math.max(Math.min(relY * pull, maxShift), -maxShift);
        el.style.transform = 'translate(' + tx + 'px,' + (ty - 2) + 'px)';
      });
      el.addEventListener('mouseleave', function(){
        el.style.transform = '';
      });
    });
  }

  /* ---------- CURSOR GLOW ---------- */
  var cursorGlow = document.getElementById('cursorGlow');
  if (cursorGlow && !isTouch && !prefersReducedMotion) {
    var glowActive = false;
    document.addEventListener('mousemove', function(e){
      cursorGlow.style.left = e.clientX + 'px';
      cursorGlow.style.top = e.clientY + 'px';
      if (!glowActive) {
        cursorGlow.classList.add('active');
        glowActive = true;
      }
    }, { passive: true });
    document.addEventListener('mouseleave', function(){
      cursorGlow.classList.remove('active');
      glowActive = false;
    });
  }

  /* ---------- MOBILE NAV ---------- */
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobileNav');

  function closeMobileNav(){
    mobileNav.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.setAttribute('aria-label', 'Open menu');
    document.body.style.overflow = '';
  }
  function openMobileNav(){
    mobileNav.classList.add('open');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.setAttribute('aria-label', 'Close menu');
    document.body.style.overflow = 'hidden';
  }
  hamburger.addEventListener('click', function(){
    var expanded = hamburger.getAttribute('aria-expanded') === 'true';
    if (expanded) closeMobileNav(); else openMobileNav();
  });
  Array.prototype.slice.call(mobileNav.querySelectorAll('a')).forEach(function(a){
    a.addEventListener('click', closeMobileNav);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeMobileNav();
  });

  /* ---------- SCROLL REVEAL ---------- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.reveal, .reveal-stagger'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('in'); });
  }

  /* ---------- FAQ ACCORDION ---------- */
  var faqItems = Array.prototype.slice.call(document.querySelectorAll('.faq-item'));
  faqItems.forEach(function(item){
    var btn = item.querySelector('.faq-q');
    var answer = item.querySelector('.faq-a');
    function sync(){
      var open = item.classList.contains('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      answer.style.maxHeight = open ? (answer.scrollHeight + 'px') : '0px';
    }
    sync();
    btn.addEventListener('click', function(){
      var willOpen = !item.classList.contains('open');
      faqItems.forEach(function(other){
        other.classList.remove('open');
        other.querySelector('.faq-a').style.maxHeight = '0px';
        other.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (willOpen) {
        item.classList.add('open');
        sync();
      }
    });
    window.addEventListener('resize', function(){
      if (item.classList.contains('open')) sync();
    });
  });

  /* ---------- NOTIFY ME -> WAITLIST CONTEXT ---------- */
  var waitlistContext = document.getElementById('waitlistContext');
  var waitlistEmail = document.getElementById('waitlistEmail');
  Array.prototype.slice.call(document.querySelectorAll('.js-notify')).forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var product = btn.getAttribute('data-product');
      if (waitlistContext) {
        waitlistContext.textContent = 'Noted — we\'ll flag you first for: ' + product;
        waitlistContext.classList.add('show');
      }
      var target = document.getElementById('newsletter');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
      setTimeout(function(){ if (waitlistEmail) waitlistEmail.focus(); }, 500);
    });
  });

  /* ---------- WAITLIST FORM (native Shopify customer form) ---------- */
  // The <form> in sections/newsletter.liquid posts directly to Shopify's
  // customer endpoint via the {% form 'customer' %} tag — no custom JS
  // needed for validation or submission. This just adds a small loading
  // state so the button feels responsive while the page round-trips.
  var waitlistForm = document.getElementById('waitlistForm');
  if (waitlistForm) {
    waitlistForm.addEventListener('submit', function(){
      var btn = document.getElementById('waitlistBtn');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Joining…';
      }
    });
  }

 /* ---------- PRODUCT GALLERY (swipeable) ---------- */
var pdpSwipe = document.getElementById('pdpSwipe');
if (pdpSwipe) {
  var pdpSlides = pdpSwipe.querySelectorAll('.pdp-slide');
  var pdpThumbs = document.querySelectorAll('.pdp-thumb');
  var pdpDots = document.querySelectorAll('.pdp-dot');

  function pdpGoTo(i){
    if (pdpSlides[i]) pdpSlides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }
  pdpThumbs.forEach(function(btn){
    btn.addEventListener('click', function(){ pdpGoTo(parseInt(btn.getAttribute('data-index'), 10)); });
  });
  pdpDots.forEach(function(dot){
    dot.addEventListener('click', function(){ pdpGoTo(parseInt(dot.getAttribute('data-index'), 10)); });
  });
  var pdpScrollTimer;
  pdpSwipe.addEventListener('scroll', function(){
    clearTimeout(pdpScrollTimer);
    pdpScrollTimer = setTimeout(function(){
      var idx = Math.round(pdpSwipe.scrollLeft / pdpSwipe.clientWidth);
      pdpThumbs.forEach(function(t,i){ t.classList.toggle('active', i===idx); });
      pdpDots.forEach(function(d,i){ d.classList.toggle('active', i===idx); });
    }, 80);
  });
}
/* ---------- CART DRAWER ---------- */
  var cartDrawer = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartToggle = document.getElementById('cartToggle');
  var cartClose = document.getElementById('cartClose');
  var cartDrawerBody = document.getElementById('cartDrawerBody');
  var cartSubtotal = document.getElementById('cartSubtotal');
  var cartCount = document.getElementById('cartCount');

  function formatMoney(cents) {
    var format = window.themeMoneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    amount = parts.join('.');
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function findCartItem(cart, key) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) return cart.items[i];
    }
    return null;
  }

  function renderCartDrawer(cart) {
    if (!cartDrawerBody) return;
    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML = '<p class="cart-empty">Your bag is empty.</p>';
    } else {
      var html = cart.items.map(function(item){
        return '<div class="cart-line">' +
          '<img src="' + item.image + '&width=160" alt="' + item.product_title + '" width="80" height="100">' +
          '<div class="cart-line-info">' +
            '<h4>' + item.product_title + '</h4>' +
            (item.variant_title ? '<span class="cart-line-variant">' + item.variant_title + '</span>' : '') +
            '<div class="cart-line-qty-row">' +
              '<div class="cart-qty-controls">' +
                '<button type="button" class="cart-qty-btn" data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">\u2212</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" class="cart-qty-btn" data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="cart-line-price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
      cartDrawerBody.innerHTML = html;
    }
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.style.display = cart.item_count > 0 ? '' : 'none';
    }
    Array.prototype.slice.call(cartDrawerBody.querySelectorAll('.cart-qty-btn')).forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-key');
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var item = findCartItem(cart, key);
        if (!item) return;
        var newQty = Math.max(0, item.quantity + delta);
        updateCartLine(key, newQty);
      });
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCartDrawer);
  }

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r){ return r.json(); }).then(renderCartDrawer);
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeCart(); });

  /* Intercept product page add-to-cart so it opens the drawer instead of reloading */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = productForm.querySelector('.pdp-add');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
      var formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      }).then(function(r){
        if (!r.ok) return r.json().then(function(err){ throw err; });
        return r.json();
      }).then(function(){
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        openCart();
      }).catch(function(err){
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        alert((err && err.description) || 'Could not add to cart. Please try again.');
      });
    });
   }})();
